import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function TwoColumnRows(props) {
    const childrenArray = React.Children.toArray(props.children);

    const rows = [];
    for (let i = 0; i < childrenArray.length; i += 2) {
        rows.push(
            <Row key={i}>
                <Col sm={6}>{childrenArray[i]}</Col>
                <Col sm={6}>{childrenArray[i + 1] || null}</Col>
            </Row>
        );
    }

    return <>{rows}</>;
}

export default TwoColumnRows;